import { ActionsUnion, createAction } from '../../../store/configureStore'
import { User } from './User.interface'

export const Actions = {
  userLoggedIn: (user: User) => createAction('USER_LOGGED_IN', { user }),
  userLoggedOut: () => createAction('USER_LOGGED_OUT')
}

export type Actions = ActionsUnion<typeof Actions>
